<template>
  <div
    id="kt_modal_contas_consultar"
    ref="kt_modal_contas_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <ConsultarConta
            ref="ConsultarConta"
            :modal="true"
            @selecionarConta="selecionarConta"
            @fecharConta="modalConsultarConta"
            @adicionarConta="adicionarConta"
            @editarConta="editarConta"
          ></ConsultarConta>
        </div>
      </div>
    </div>
  </div>
  <EditarContaModal
    v-if="exibirEditarConta"
    @cancelarConta="modalEditarConta"
    @confirmarConta="confirmarConta"
    :idConta="idConta"
    :conta="conta"
  ></EditarContaModal>
</template>

<script>
import ConsultarConta from "@/views/contas/Consultar.vue";
import EditarContaModal from "@/views/contas/ContaModal.vue";
import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["selecionarConta", "exibirModalContas"],
  components: {
    ConsultarConta,
    EditarContaModal,
  },
  methods: {
    modalConsultarConta(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalContas", false);
      }
    },
    selecionarConta(conta) {
      this.$emit("selecionarConta", conta);
      this.modalConsultarConta(false);
      hideModalId("kt_modal_contas_consultar");
    },
    adicionarConta(data) {
      if (data === null) {
        this.idConta = 0;
        this.conta = null;
        this.modalEditarConta(true);
      } else {
        this.idConta = 0;
        this.conta = data;
        this.modalEditarConta(true);
      }
    },
    editarConta(data) {
      this.idConta = data.id;
      this.conta = data;
      this.modalEditarConta(true);
    },
    modalEditarConta(exibir) {
      this.exibirEditarConta = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_conta_editar",
          /*open*/ () => {
            this.$utils.requestFocus("txtDescricaoConta");
          },
          /*close*/ () => {
            this.modalEditarConta(false);
          }
        );
      }
    },
    confirmarConta() {
      this.modalEditarConta(false);
      hideModalId("kt_modal_conta_editar");
      this.$refs.ConsultarConta.carregarContas();
      this.$refs.ConsultarConta.focusCurrentNode();
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  data() {
    return {
      idConta: 0,
      exibirEditarConta: false,
      conta: {},
    };
  },
};
</script>

<style></style>
